"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const l = (a) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...a,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.625 6.25A2.377 2.377 0 0 0 3.25 8.625v6.74a2.377 2.377 0 0 0 2.375 2.375h12.75a2.377 2.377 0 0 0 2.375-2.375v-6.74a2.377 2.377 0 0 0-2.375-2.375zm12.75 12.74H5.625A3.63 3.63 0 0 1 2 15.365v-6.74A3.63 3.63 0 0 1 5.625 5h12.75A3.63 3.63 0 0 1 22 8.625v6.74a3.63 3.63 0 0 1-3.625 3.625M12 8.7a1.281 1.281 0 0 0 0 2.561A1.281 1.281 0 0 0 12 8.7m0 3.811A2.533 2.533 0 0 1 9.47 9.98 2.53 2.53 0 0 1 12 7.45a2.53 2.53 0 0 1 2.53 2.53A2.533 2.533 0 0 1 12 12.511m3.16 3.833a.625.625 0 0 0 1.25 0v-1.351a2.273 2.273 0 0 0-2.272-2.271H9.861a2.27 2.27 0 0 0-2.27 2.27v1.352a.625.625 0 0 0 1.25 0v-1.351c0-.563.458-1.021 1.02-1.021h4.277c.563 0 1.021.458 1.021 1.02z",
        clipRule: "evenodd"
      }
    )
  }
), d = e(l);
export {
  d as Card,
  d as default
};
